var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-radio-group',{on:{"change":_vm.handleChange},model:{value:(_vm.propsModel.value),callback:function ($$v) {_vm.$set(_vm.propsModel, "value", $$v)},expression:"propsModel.value"}},_vm._l((_vm.dictOptions),function(item){return _c('a-radio',{attrs:{"value":item.itemValue}},[_vm._v(" "+_vm._s(item[_vm.fieldKey])+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }